import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ConfirmCancelTransitDecision, FormMode, Languages, ServiceStatus, TransitCancelWorkflowSteps, TransitRequestWFSteps } from 'src/app/shared/models/enums.model';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { User } from 'src/app/front-user/shared/models/user.model';
import { TransitAdminDto } from '../../shared/models/transit-admin.model';
import { TransitRequestComponent } from 'src/app/front-user/services/e-booking/transit-request/transit-request.component';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { TransitAdminService } from '../../shared/services/transit-admin.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { CustomValidators } from 'src/app/front-user/shipyard-service/models/custom-validator';
import { first } from 'rxjs/operators';
import { TransitService } from 'src/app/front-user/services/e-booking/transit-request/transit-request.service';
import { TransitRequestDto } from 'src/app/front-user/services/e-booking/transit-request/transit-request.model';
import { FeesEstimate } from 'src/app/front-user/services/e-booking/fees-estimation-request/fees-estimate.model';
import { TransitRequestCustomDTO } from 'src/app/shared/models/transit-request-custom-dto.model';
import { WFHistoryService } from 'src/app/shared/services/wfhistory.service';
import { GenericLookup } from 'src/app/shared/models/general.model';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-marine-confirm-cancel-transit',
  templateUrl: './marine-confirm-cancel-transit.component.html',
})
export class MarineConfirmCancelTransitComponent implements OnInit {
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  stepId: number = TransitRequestWFSteps.ConfirmCancelTransit;
  MarineConfirmCancelTransitForm: FormGroup;
  AntipollutionPaymentForm: FormGroup;
  submitted: boolean = false;
  showRequest: boolean = false;
  isErrorMessage: boolean = false;
  editFlag: boolean = false;
  cancelFlage: boolean = false;
  LateBookingFlag: boolean = false;
  public Languages: any = Languages;
  newTransitDate: Date;
  oldTransitDate: Date;
  actionDateModified: Date;
  bookingDate: Date;
  //cancelDate: Date;
  lockTaskErrorMessage: boolean = false;
  loading = false;
  baseRequestId: string = '';
  requestStatus: number;
  baseRequestDTO: BaseRequest //= new BaseRequest();
  displayedLang: any;
  currentUser: User = new User();
  transitRequestCustomObj: TransitRequestCustomDTO = new TransitRequestCustomDTO();
  adminDecisionObject: TransitAdminDto = new TransitAdminDto();
  isLoaded: boolean = false;
  @ViewChild('TransitRequest', { static: false }) TransitRequest: TransitRequestComponent;
  @ViewChild('TransitIssueResolution', { static: false }) TransitIssueResolution: any;
  isAdmin: boolean;
  numberRegex: any = /^[0-9]+(\.[0-9]+)?$/;
  error: any = { isError: false, errorMessage: '' };
  transitData: TransitRequestDto = new TransitRequestDto();
  responseObj: ResponseObject = new ResponseObject();
  FeesEstimateObj: FeesEstimate = new FeesEstimate();
  @Input() public isShow: boolean = true;
  stepHistoryId: any;
  stepData: any;
  @Input() isReadOnly: boolean = false;
  appInstanceId: string = '';
  public transitRequestIdd: string = '';
  public penaltyIdToSearch: string = '';
  decision = ConfirmCancelTransitDecision;
  decisionKeys = Object.keys(this.decision);
  latestStepId: number;
  requestStatuses: number[] = [];
  decisionValue: number;


  constructor(
    private formBuilder: FormBuilder,
    private baseRequestService: BaseRequestService,
    private transitService: TransitService,
    private globalSrv: GlobalServices,
    private alertService: AlertService,
    private transitSrv: TransitService,
    private wfhistoryService: WFHistoryService,
    private router: Router,
    private datePipe: DatePipe  // Add DatePipe


  ) {
    this.decisionKeys = this.decisionKeys.slice(this.decisionKeys.length / 2);
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    //this.baseRequestId = "A1EABCF5-33FE-427C-A871-93ECEEF05F0F";
    if (history.state.data && history.state.data.requestId) {
      this.stepHistoryId = history.state.data.stepHistoryId;
      this.baseRequestId = history.state.data.requestId;
      this.getBaseRequest();
    } else {
      window.history.back();
    }
    this.currentUser = this.globalSrv.user;
  }

  ngOnInit() {
    this.buildForm(null);
  }

  buildForm(decision) {
    this.MarineConfirmCancelTransitForm = this.formBuilder.group({
      Decision: ['', Validators.required],
      MarineNote: [''],
      OldTransitDate: new FormControl({ value: '', disabled: true }), // Date only
      NewTransitDate: new FormControl({ value: '', disabled: true }), // Date only
      ActionDateModified: new FormControl({ value: '', disabled: true }), // Date + Time
      ActionTimeModified: new FormControl({ value: '', disabled: true }), // Time picker
    });
  }

  get f() { return this.MarineConfirmCancelTransitForm.controls; }

  receiveLatestStepId(event) {
    if (event === undefined) return;
    this.latestStepId = event;
  }

  getBaseRequest() {
    this.baseRequestService.getBaseRequest(this.baseRequestId).subscribe(
      d => {
        this.baseRequestDTO = d.Data;
        const cancelDate = d.Data?.['CancelationDate'];
        if (cancelDate) {
          this.actionDateModified = new Date(cancelDate);
          this.MarineConfirmCancelTransitForm?.patchValue({
            ActionDateModified: this.actionDateModified,
            ActionTimeModified: this.actionDateModified
          });
        }
        // this.requestStatus = this.baseRequestDTO.StatusId;
        this.requestStatuses = this.baseRequestDTO.RequestStatuses.map(s => s.StatusId);
        if (history.state.data && history.state.data.isCompleted && history.state.data.StepId == this.stepId) { // Request History
          this.formMode = FormMode.Readonly;
          this.getTransitRequestWFHistoryById();
        } else if (!this.requestStatuses.includes(ServiceStatus.Transit_PendingConfirmCancelTransit)) {
          this.formMode = FormMode.Readonly;
          this.getTransitRequest();
          this.getTransitRequestWFHistory();
        } else if (this.requestStatuses.includes(ServiceStatus.Transit_PendingConfirmCancelTransit)) { // New Mode But comming from other path
          this.formMode = FormMode.Add;

          // this.latestStepId = this.TransitRequest.transitRequest.LatestStepId;
        }
        this.getTransitRequest();
      }
    )
  }


  public getTransitRequest() {
    this.transitSrv.get(this.baseRequestId).pipe(first()).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.transitData = resObj.Data;
          const agentDate = resObj.Data?.['AgentTransitDate'];
          if (agentDate) {
            this.oldTransitDate = new Date(agentDate);
            this.MarineConfirmCancelTransitForm?.patchValue({
              OldTransitDate: this.oldTransitDate
            });
          }
        }
      });
  }

  getTransitRequestWFHistory() {
    this.wfhistoryService.getByRequestIdByStepId(this.baseRequestId, this.stepId).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.stepData = this.responseObj.Data["StepData"] ? JSON.parse(this.responseObj.Data["StepData"]) : null;
          this.getTransitRequestWFHistoryCompleted(this.stepData);
        }
      }

    );
  }

  getTransitRequestWFHistoryById() {
    this.wfhistoryService.getByRequestIdByStepIdById(this.baseRequestId, this.stepId, this.stepHistoryId).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        this.stepData = this.responseObj.Data["StepData"] ? JSON.parse(this.responseObj.Data["StepData"]) : null;
        this.getTransitRequestWFHistoryCompleted(this.stepData);
      }

    );
  }

  getTransitRequestWFHistoryCompleted(stepData: any) {
    if (!stepData) return;
    this.decisionValue = this.stepData.Decision;
    this.MarineConfirmCancelTransitForm.patchValue({
      Decision: this.decisionValue,
      MarineNote: this.stepData.MarineNote,
      OldTransitDate: this.oldTransitDate

    });
    this.MarineConfirmCancelTransitForm.disable();
  }


  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.MarineConfirmCancelTransitForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    this.transitRequestCustomObj.RequestId = this.baseRequestId;
    this.transitRequestCustomObj.StepId = this.stepId;
    this.transitRequestCustomObj.StepData = JSON.stringify(this.MarineConfirmCancelTransitForm.getRawValue());
    this.transitRequestCustomObj.CompletedBy = this.currentUser.UserName;
    this.transitRequestCustomObj.ComponentURL = this.router ? this.router.url.split('/')[1] + '/' + this.router.url.split('/')[2] : '';
    this.transitRequestCustomObj.IsAdmin = this.currentUser.IsAdmin;
    //this.transitRequestCustomObj.DirectionId = this.TransitRequest?.feesRequest?.feesDetailsForm.get('DirectionId')?.value;
    this.transitRequestCustomObj.DirectionId = this.TransitRequest.feesRequest?.feesDetailsForm.get('DirectionId')?.value;


    this.transitService.SubmitConfirmCancelTransitDecision(this.transitRequestCustomObj)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            this.MarineConfirmCancelTransitForm.reset();
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            this.loading = false;
          }

        });
  }

}
